/**
 *
 * AccountCancellation
 *
 */

import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
//import TabBar from '@/components/TabBar.vue';
//import Spinner from '@/components/Spinner.vue';

export default {
  name: 'AccountCancellation',

  components: {
    SharedHeader,
    SharedFooter,
    //TabBar,
    //Spinner,
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
